document.addEventListener('DOMContentLoaded', () => {

  // let select = Array.prototype.slice.call(document.querySelectorAll('.js-form-type-select .form-select'));
  // if (select.length > 0) {
  //   select.forEach(($el) => {
  //     $el.addEventListener('click', () => {
  //       $el.parentElement.classList.toggle('opened');
  //     })
  //   })
  // }

  let toggler = Array.prototype.slice.call(document.getElementsByClassName('toggler'));

  if (toggler.length > 0) {
    toggler.forEach(function(el) {
      el.addEventListener('click', () => {
        let $target = el.querySelector('.togglee');
        if ($target.id == el.dataset.id) {
          el.classList.toggle('is-clicked');
          $target.classList.toggle('is-active');
        }
      }, {passive: true});
    });
  }
}, {passive: true})

// html example
//<div class="toggler" data-id="contact-{{ loop.index }}"></div>
//<div class="togglee" id="contact-{{ loop.index }}"></div>
